import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';

export default [
  {
    path: '/advisor/account-opening/:sectionId?',
    name: 'ClientAuthByElement',
    component: () => import('@advisor/components/clientAuthentication/accountOpening/Index'),
    meta: {
      breadCrumbs: {
        to: '/advisor/account-opening',
        text: '',
        title: 'Client Authentication',
        componentId: COMPONENT_ID.CLIENT_AUTHENTICATION,
      },
      platformArea: PLATFORM_AREA.CLIENT_AUTHENTICATION,
      visibilityComponentId: COMPONENT_ID.CLIENT_AUTHENTICATION,
      riaComponent: RIA_COMPONENT.CLIENT_AUTH_ACCOUNT_OPENING,
    },
    props: true,
  },
  {
    path: '/advisor/account-opening/:sectionId?/search/:searchValue',
    name: 'ClientAuthQuickSearch',
    component: () => import('@advisor/components/clientAuthentication/accountOpening/Index'),
    meta: {
      breadCrumbs: {
        to: '/advisor/account-opening',
        text: '',
        title: 'Client Authentication',
        componentId: COMPONENT_ID.CLIENT_AUTHENTICATION,
      },
      platformArea: PLATFORM_AREA.CLIENT_AUTHENTICATION,
      visibilityComponentId: COMPONENT_ID.CLIENT_AUTHENTICATION,
      riaComponent: RIA_COMPONENT.CLIENT_AUTH_ACCOUNT_OPENING,
    },
    props: true,
  },
  // This  is the sub route to the kyc account opening process
  {
    path: '/advisor/account-opening-details/:requestId/:clUserId',
    name: 'KycAccountDetails',
    component: () => import('@advisor/components/clientAuthentication/kycAccountDetails/Index'),
    meta: {
      breadCrumbs: {
        to: '/advisor/account-opening',
        text: 'Client Authentication/',
        title: 'Client Authentication',
        componentId: COMPONENT_ID.CLIENT_AUTHENTICATION,
      },
      platformArea: PLATFORM_AREA.CLIENT_AUTHENTICATION,
      visibilityComponentId: COMPONENT_ID.CLIENT_AUTHENTICATION,
      riaComponent: RIA_COMPONENT.CLIENT_AUTH_ACCOUNT_OPENING,
    },
    props: (route) => ({
      requestId: Number(route.params.requestId),
      clUserId: Number(route.params.clUserId),
    }),
  },
  {
    path: '/advisor/bank-linking/:sectionId?',
    name: 'ClientAuthBankLinkByElement',
    component: () => import('@advisor/components/clientAuthentication/bankLinking/Index'),
    meta: {
      breadCrumbs: {
        to: '/advisor/bank-linking',
        text: '',
        title: 'Bank Linking',
        componentId: COMPONENT_ID.CLIENT_AUTH_BANK_LINKING,
      },
      platformArea: PLATFORM_AREA.CLIENT_AUTH_BANK_LINKING,
      visibilityComponentId: COMPONENT_ID.CLIENT_AUTH_BANK_LINKING,
      riaComponent: RIA_COMPONENT.CLIENT_AUTH_BANK_LINKING,
    },
    props: true,
  },
];
